import { Button } from 'primereact/button';
import { DocumentOverviewCapTableRow } from './colDefsDocumentOverviewCapTable';

export const OptionCell = (props: { data: DocumentOverviewCapTableRow }) => {
  return (
    <div className="flex gap-2 align-items-center">
      <Button
        icon="pi pi-pen-to-square"
        rounded
        text
        aria-label="Edit"
        onClick={() => props.data.handleEdit()}
      />
      <Button
        icon="pi pi-trash"
        rounded
        text
        aria-label="Delete"
        severity="danger"
        onClick={() => props.data.handleDelete()}
      />
    </div>
  );
};
